// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","hamburger":"Header_hamburger__gyFYw","hamburgerOpen":"Header_hamburgerOpen__qGXOQ"};